import styled from "styled-components";
import { Modal } from "antd";

export const ModalContainer = styled(Modal)`
  .Heading {
    font-size: 16px;
    letter-spacing: 0.6px;
  }
  .ant-modal-header {
    padding: 0px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom: none !important;
    background-color: var(--border-color) !important;
  }

  .ant-modal-content {
    border: 1px solid var(--border-color) !important;
    border-radius: 12px;
    background-color: var(--primary-bg) !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 6px;
    height: 40px;
    align-items: center;
    background-color: var(--primary-bg) !important;
    border: 1px solid var(--border-color) !important;
  }

  .ant-input-affix-wrapper {
    border: none !important;
    box-shadow: none;
    .ant-input {
      border: none !important;
      border-radius: 0px;
    }
  }
  .ant-select {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
    font-size: 16px;
  }
  .ant-select-arrow {
    color: var(--primary-text-color);
  }
  .ant-select-item {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
  }
  .ant-select-dropdown {
    background-color: var(--primary-bg) !important;
    border: 1px solid var(--border-color) !important;
    border-radius: 6px;
  }

  .ant-select-selector {
    border-radius: 6px;
    height: 40px;
    align-items: center;
    border: 1px solid #8a3ef4;
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #8a3ef4 !important;
  }

  // .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item {
  //   line-height: 0px;
  // }
  .ant-input {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum", "tnum";
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    // color: var(--text-primary) !important;
    font-size: 14px;
    line-height: 1.5715;
    background-image: none;
    border-radius: 6px;
    height: 40px;
    transition: all 0.3s;
  }
  .ant-input:focus,
  .ant-input:hover {
    border-color: #8a3ef4 !important;
    color: #000;
  }

  .ant-form-item-label > label {
    font-size: 16px;
    color: var(--primary-text-color);
  }
  .ant-form-item label {
    color: var(--primary-text-color);
  }
  .ant-modal-close-x {
    display: none;
  }
  .ant-segmented {
    background-color: var(--border-color) !important;
    height: 38px;
  }
  .ant-segmented-thumb {
    background-color: var(--primary-bg);
  }
  .ant-segmented-item {
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--secondary-text-color) !important;

    &:hover {
      color: none !important;
    }
  }
  .ant-segmented-item-selected {
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-segmented-item-label {
    font-size: 16px;
    font-weight: 600;
  }
  .ant-segmented-item-selected {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color) !important;
  }
  input:-webkit-autofill {
    box-shadow: 0 0 0 1000px var(--primary-bg) inset !important;
    -webkit-box-shadow: 0 0 0 1000px var(--primary-bg) inset !important;
    -webkit-text-fill-color: var(
      --primary-text-color
    ) !important; /* Optional: text color */
  }
  .ant-picker {
    background: var(--primary-bg);
    color: var(--primary-text-color);
    height: 40px;
    border-radius: 6px;
    border: 1px solid var(--border-color);

    &:hover {
      border-color: #8a3ef4;
    }
  }
  .ant-picker-panel-container{
    background-color: var(--primary-bg);
    color: var(--primary-text-color);
    border: 1px solid var(--border-color);
  }
  .ant-picker-header{
    border-bottom: 1px solid var(--border-color);
    color: var(--primary-text-color);
  }
  .ant-picker-input > input, .ant-picker-suffix , 
  .ant-picker-header button , 
  .ant-picker-content th, .ant-picker-cell-in-view {
    color: var(--primary-text-color);
  }
  .ant-picker-cell-in-view: hover{
    color: #000;
  }
  .ant-picker-cell-disabled{
    color: var(--secondary-text-color);
  }
  .ant-picker-time-panel-column>li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner{
    color: var(--primary-text-color);

    &:hover{
      color: #000;
    }
  }
  .ant-picker-datetime-panel .ant-picker-time-panel , .ant-picker-time-panel-column:not(:first-child) {
    border-left: 1px solid var(--border-color);
  }
  .ant-picker-panel .ant-picker-footer{
    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
  }
  .ant-btn-sm {
    color: var(--primary-text-color);
  }

  .close-icon {
    position: absolute;
    left: 95%;
    cursor: pointer;
    color: var(--primary-text-color);

    @media screen and (max-width: 560px) {
      left: 92%;
    }
  }
`;

export const VideoModalWrapper = styled.div`
  .custom-video-modal {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal-content {
    position: relative;
    background-color: var(--primary-bg);
    max-width: 800px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
  }
  .modal-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }
  .modal-video-wrapper {
    position: relative;
    padding-top: 56.25%;
  }

  .modal-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .modal-footer {
    font-size: 18px;
    font-weight: 600;
    padding: 1rem;
    background-color: var(--primary-bg);
    color: var(--primary-text-color);
  }
`;
